<template>
  <div class="bg-white">
    <div class="tab-data__wrapper">
      <div class="tab-data__content no-top-border">
        <!-- <img class="mx-auto tab-data__img"
            src="@/assets/img/bank-connect.svg" alt="bank-connect" /> -->
        <div class="connect-text text-center font-weight-bold font-size-18">
          {{ $t("sardine.text1") }}
        </div>
        <div class="connect-text text-center mt-1">
          {{ $t("sardine.text2") }}
        </div>
        <div class="connect-text text-center mt-1">
          {{ $t("sardine.text3") }}
        </div>
        <div class="d-flex justify-content-center  mt-2">
          <CustomButton
            :name="$t('sardine.continue')"
            @handle-click="placeOrderOnramp()"
            className="btn btn-md w-100 button-default-outline"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
// import Loading from '@/components/Loading.vue';
import CustomButton from '../views/customButton.vue';

export default {
  name: 'sardine',
  components: {
    CustomButton,
    // Loading,
  },
  props: {
    rootConvertedData: Object || {},
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters({
      cart: 'user/cart',
      displayCurrency: 'user/displayCurrency',
      marketInfo: 'user/marketInfo',
      userInfo: 'user/userInfo',
      currencies: 'user/currencies',
      bankAccount: 'user/bankAccount',
    }),
  },
  async mounted() {
    this.isLoading = true;
    this.isLoading = false;
  },
  methods: {
    placeOrderOnramp() {
      this.setValue({ connect: 'onramp' });
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-data {
  &__img {
    width: 80px;
  }
  &__content {
    line-height: 2rem;
    align-items: center;
  }
}
.connect-text {
  align-items: center;
  width: 100%;
  font-size: 14px;
}
.font-size-18 {
  font-size: 1.2rem;
}
</style>
